module.exports = __webpack_public_path__ + "img/frame (162).4f54974c.jpg";